
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 .5H.5V3A2.5 2.5 0 003 .5zm6.667 0H8A7.5 7.5 0 01.5 8v1.667c5.067 0 9.167-4.109 9.167-9.167zM6.333.5H4.667A4.167 4.167 0 01.5 4.667v1.666A5.833 5.833 0 006.333.5zm0 15H8A7.5 7.5 0 0115.5 8V6.333A9.167 9.167 0 006.333 15.5zm6.667 0h2.5V13a2.5 2.5 0 00-2.5 2.5zm-3.333 0h1.666a4.167 4.167 0 014.167-4.167V9.667A5.833 5.833 0 009.667 15.5z","fill-opacity":".7"}})])
          )
        }
      }
    